<template>
	<div class="power-station-page">
		<management-table
			title="电站管理"
			eyebrow="Power Station"
			:data="tableData"
			:loading="loading"
			:current-page="query.pageNum"
			:page-size="query.pageSize"
			:total="total"
			empty-text="暂无电站数据"
			table-class="power-station-table"
			:mobile-collapsible-filters="true"
			:mobile-min-row-height="88"
			@current-change="onPageChange"
		>
			<template slot="filters">
						<!-- 电站名称 -->
						<div class="search-item">
							<div class="search-label">电站名称：</div>
							<div>
								<el-select
									v-model="query.stationId"
									placeholder="请选择或输入电站名称"
									clearable
									filterable
									:filter-method="filterStation"
									@visible-change="onStationDropdownVisible"
									class="search-select"
								>
									<el-option
										v-for="item in stationList"
										:key="item.id"
										:label="item.stationName"
										:value="item.id"
									/>
								</el-select>
							</div>
						</div>
						<!-- 公司名称 -->
						<div class="search-item">
							<div class="search-label">公司名称：</div>
							<div>
								<el-input 
									placeholder="请输入公司名称搜索" 
									v-model="query.companyName"
									class="search-input"
								/>
							</div>
						</div>
						<!-- 电站类型 -->
						<div class="search-item">
							<div class="search-label">电站类型：</div>
							<div>
								<el-select 
									v-model="query.stationType" 
									placeholder="请选择电站类型" 
									clearable
									class="search-select"
								>
									<el-option value="1" key="1" label="基站叠光">基站叠光</el-option>
									<el-option value="2" key="2" label="离网电站">离网电站</el-option>
								</el-select>
							</div>
						</div>
			</template>
			<template slot="actions">
				<el-button type="primary" icon="el-icon-search" @click="serch" class="search-btn">搜索</el-button>
				<el-button type="primary" icon="el-icon-plus" @click="addDevice" v-if="canEdit === 1" class="add-btn">新增电站</el-button>
			</template>
			<template slot="columns">
						  <el-table-column
						  show-overflow-tooltip
						  width="120"
						    label="站点图片">
						     <template slot-scope="scope">
								<el-image v-if="scope.row.picUrl != ''"
									class="station-image"
								    :src="scope.row.picUrl" 
									@click="viewPic(scope.row.picUrl)"
								    :preview-src-list="srcList">
								</el-image>
								<div v-else class="station-image station-image-empty">
									暂无图片
								</div>
							 </template>
						  </el-table-column>
						  <el-table-column
							min-width="100"
						    label="站点名称"
						    show-overflow-tooltip>
						    <template slot-scope="scope">
								<span class="ellipsis-cell" :title="scope.row.stationName">{{ scope.row.stationName }}</span>
							</template>
						  </el-table-column>
						  <el-table-column
							width="100"
						    label="电站类型">
						    <template slot-scope="scope">
								<span v-if="scope.row.stationType == 1">基站叠光</span>
								<span v-if="scope.row.stationType == 2">离网电站</span>
						    </template>
						  </el-table-column>
						  <el-table-column
							width="100"
						    label="消纳类型">
						    <template slot-scope="scope">
								<span v-if="scope.row.consumptionType == 1">全部自用</span>
								<span v-if="scope.row.consumptionType == 2">余额上网</span>
								<span v-if="scope.row.consumptionType == 3">全额上网</span>
						    </template>
						  </el-table-column>
						  <el-table-column
							min-width="150"
						    label="站点位置">
						    <template slot-scope="scope">
						  		<span>{{ scope.row.stationAddress }}</span>
						    </template>
						  </el-table-column>
						  <el-table-column
						    label="负责人"
							width="80"
						    show-overflow-tooltip>
						    <template slot-scope="scope">{{ scope.row.userName }}</template>
						  </el-table-column>
						  <el-table-column
						    label="电话"
							width="120"
						    show-overflow-tooltip>
						    <template slot-scope="scope">{{ scope.row.linkMobile }}</template>
						  </el-table-column>
						  <el-table-column
						    label="注册时间"
							width="140"
						    show-overflow-tooltip>
						    <template slot-scope="scope">{{ scope.row.registrationTime }}</template>
						  </el-table-column>
						  <el-table-column
						    label="开通时间"
							width="140"
						    show-overflow-tooltip>
						    <template slot-scope="scope">{{ scope.row.openTime }}</template>
						  </el-table-column>
						  <el-table-column
						    label="装机容量"
							width="100"
						    show-overflow-tooltip>
						    <template slot-scope="scope">{{ scope.row.installedCapacity }}</template>
						  </el-table-column>
						  <el-table-column
							:width="operationColumnWidth"
							fixed="right"
						    label="操作">
						    <template slot-scope="scope">
								<div class="station-table-actions">
								<label class="station-table-action"
								@click="infoView(scope.row.id);formTitle='查看电站'">查看</label>
								<label class="station-table-action"
								@click="infoView(scope.row.id);formTitle='编辑电站'" v-if="canEdit === 1">编辑</label>
								<label class="station-table-action"
								@click="deleteRow(scope.row.id)" title="点击删除" v-if="canEdit === 1">删除</label>
								</div>
							</template>
						  </el-table-column>
			</template>
		</management-table>
		<!-- 电站新增/编辑/查看弹窗：深蓝调 -->
		<el-dialog
		  :title="formTitle"
		  :visible.sync="showAdd"
		  width="850px"
		  class="station-form-dialog-wrapper"
		  custom-class="station-dialog"
		>
		  <el-form 
		  	ref="formObjectForm" 
		  	:model="addFormObject" 
		  	size="medium" 
		  	label-position="right" 
		  	label-width="90px"
		  	:class="{'detail-view-form': formTitle=='查看电站'}"
			style="color: var(--solar-text, #87CEFA);"
		  >
			  <div v-if="formTitle=='新增电站'" class="station-form-section-title">电站信息</div>
			  <el-row>
				  <el-col :span="12">
					  <el-form-item label="公司名称" prop="companyName" :class="{'is-required': formTitle!='查看电站'}">
					    <el-input 
					    	v-model="addFormObject.companyName" 
					    	maxlength="50" 
					    	placeholder="请输入公司名称" 
					    	v-if="formTitle!='查看电站'"
					    	class="dialog-input"
					    />
						<el-row v-if="formTitle=='查看电站'">{{addFormObject.companyName}}</el-row>
					  </el-form-item>	  
				  </el-col>
				  <el-col :span="12">
					  <el-form-item label="站点名称" prop="stationName" :class="{'is-required': formTitle!='查看电站'}">
					    <el-input 
					    	v-model="addFormObject.stationName" 
					    	maxlength="50" 
					    	placeholder="请输入站点名称" 
					    	v-if="formTitle!='查看电站'"
					    	class="dialog-input"
					    />
						<el-row v-if="formTitle=='查看电站'">{{addFormObject.stationName}}</el-row>
					  </el-form-item>
				  </el-col>
			  </el-row>
			  <el-row>
				  <el-col :span="12">
					  <el-form-item label="电站类型" prop="stationType" :class="{'is-required': formTitle!='查看电站'}">
						  <el-select 
						  	v-model="addFormObject.stationType" 
						  	placeholder="请选择电站类型" 
						  	clearable
						  	style="width: 316px;" 
						  	v-if="formTitle!='查看电站'"
						  	class="dialog-select"
						  >
						  	<el-option :value="1" :key="1" label="基站叠光">基站叠光</el-option>
						  	<el-option :value="2" :key="2" label="离网电站">离网电站</el-option>
						  </el-select>
						<el-row v-if="formTitle=='查看电站'">{{addFormObject.stationTypeText}}</el-row>
					  </el-form-item>	  
				  </el-col>
				  <el-col :span="12">
					  <el-form-item label="投资主体" prop="investBody" :class="{'is-required': formTitle!='查看电站'}">
						<el-input
							v-model="addFormObject.investBody" 
							maxlength="50"
							placeholder="请输入投资主体" 
							v-if="formTitle!='查看电站'"
							class="dialog-input"
						/>
						<el-row v-if="formTitle=='查看电站'">{{addFormObject.investBody}}</el-row>
					  </el-form-item>
				  </el-col>
			  </el-row>
			  <el-row>
				  <el-col :span="12">
					  <el-form-item label="消纳类型" prop="consumptionType" :class="{'is-required': formTitle!='查看电站'}">
						  <el-select 
						  	v-model="addFormObject.consumptionType" 
						  	placeholder="请选择消纳类型" 
						  	clearable
						  	style="width: 316px;" 
						  	v-if="formTitle!='查看电站'"
						  	class="dialog-select"
						  >
							<el-option :value="1" :key="1" label="全部自用">全部自用</el-option>
							<el-option :value="2" :key="2" label="余额上网">余额上网</el-option>
							<el-option :value="3" :key="3" label="全额上网">全额上网</el-option>
						  </el-select>
						<el-row v-if="formTitle=='查看电站'">{{addFormObject.consumptionTypeText}}</el-row>
					  </el-form-item>	  
				  </el-col>
				  <el-col :span="12">
					  <el-form-item label="站点位置" prop="stationAddress" :class="{'is-required': formTitle!='查看电站'}">
						<!-- 核心修改：移除readonly，修改placeholder，绑定新的点击方法 -->
						<el-input
							v-model="addFormObject.stationAddress" 
							maxlength="50"
							placeholder="请手动输入或点击选择站点位置" 
							v-if="formTitle!='查看电站'" 
							@click.native="openMapSelect"
							class="dialog-input"
						/>
						<el-row v-if="formTitle=='查看电站'">{{addFormObject.stationAddress}}</el-row>
					  </el-form-item>
				  </el-col>
			  </el-row>
			  <el-row>
				  <el-col :span="12">
					  <el-form-item label="负责人" prop="userName" :class="{'is-required': formTitle!='查看电站'}">
						<el-input 
							v-model="addFormObject.userName" 
							maxlength="50" 
							placeholder="请输入负责人" 
							v-if="formTitle!='查看电站'"
							class="dialog-input"
						/>
						<el-row v-if="formTitle=='查看电站'">{{addFormObject.userName}}</el-row>
					  </el-form-item>  
				  </el-col>
				  <el-col :span="12">
					  <el-form-item label="联系电话" prop="linkMobile" :class="{'is-required': formTitle!='查看电站'}">
						<el-input 
							v-model="addFormObject.linkMobile" 
							maxlength="50" 
							placeholder="请输入联系电话" 
							v-if="formTitle!='查看电站'"
							class="dialog-input"
						/>
						<el-row v-if="formTitle=='查看电站'">{{addFormObject.linkMobile}}</el-row>
					  </el-form-item>
				  </el-col>
			  </el-row>
			  <el-row>
				  <el-col :span="12">
					  <el-form-item label="装机容量" prop="installedCapacity" :class="{'is-required': formTitle!='查看电站'}">
						<el-input
							v-model="addFormObject.installedCapacity"
							maxlength="50"
							placeholder="请输入装机容量"
							v-if="formTitle!='查看电站'"
							class="dialog-input"
						/>
						<el-row v-if="formTitle=='查看电站'">{{addFormObject.installedCapacity}}</el-row>
					  </el-form-item>
				  </el-col>
				  <el-col :span="12">
					  <el-form-item label="单价(元)" prop="priceOfMoney" :class="{'is-required': formTitle!='查看电站'}">
						<el-input
							v-model="addFormObject.priceOfMoney"
							maxlength="50"
							placeholder="请输入单价"
							v-if="formTitle!='查看电站'"
							min="0"
							class="dialog-input"
						/>
						<el-row v-if="formTitle=='查看电站'">{{addFormObject.priceOfMoney}}</el-row>
					  </el-form-item>
				  </el-col>
			  </el-row>
			  <el-row>
				  <el-col :span="12">
					  <el-form-item label="注册时间" prop="registrationTime" :class="{'is-required': formTitle=='编辑电站'}">
						<el-date-picker
						  v-if="formTitle!='查看电站'"
						  style="width: 316px;"
						  v-model="addFormObject.registrationTime"
						  format="yyyy-MM-dd HH:mm:ss"
						  value-format="yyyy-MM-dd HH:mm:ss"
						  type="datetime"
						  popper-class="station-date-picker-panel"
						  :placeholder="formTitle=='新增电站' ? '选填，默认当前时间' : '选择日期时间'"
						  class="dialog-picker"
						>
						</el-date-picker>
						<el-row v-if="formTitle=='查看电站'">{{addFormObject.registrationTimeText}}</el-row>
					  </el-form-item>  
				  </el-col>
				  <el-col :span="12">
					  <el-form-item label="开通时间" prop="openTime" :class="{'is-required': formTitle=='编辑电站'}">
						<el-date-picker
						  style="width: 316px;"
						  v-if="formTitle!='查看电站'"
						  v-model="addFormObject.openTime"
						  format="yyyy-MM-dd HH:mm:ss"
						  value-format="yyyy-MM-dd HH:mm:ss"
						  type="datetime"
						  popper-class="station-date-picker-panel"
						  :placeholder="formTitle=='新增电站' ? '选填，默认当前时间' : '选择日期时间'"
						  class="dialog-picker"
						>
						</el-date-picker>
						<el-row v-if="formTitle=='查看电站'">{{addFormObject.openTimeText}}</el-row>
					  </el-form-item>
				  </el-col>
			  </el-row>
			  <el-row>
				  <el-col :span="24">
					  <el-form-item label="电站图片" prop="picUrl" :class="{'is-required': formTitle!='查看电站'}">
						  <el-upload
						    class="avatar-uploader"
						    :class="{'is-uploading': stationImageUploading}"
						    action="/api/upload/presign"
						    :show-file-list="false"
							:http-request="handleAvatarSuccess"
							:before-upload="beforeAvatarUpload"
							:disabled="stationImageUploading"
							v-if="formTitle!='查看电站'"
						  >
						    <img v-if="imageUrl" :src="imageUrl" class="avatar">
						    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
						  </el-upload>
						  <img v-if="formTitle=='查看电站' && imageUrl" :src="imageUrl" class="avatar" style="margin-top: 10px;">
					  </el-form-item>	  
				  </el-col>
			  </el-row>
			  <div v-if="formTitle=='新增电站'" class="station-form-section-title station-device-section-title">设备信息</div>
			  <el-row v-if="formTitle=='新增电站'">
				  <el-col :span="12">
					  <el-form-item label="设备型号" prop="deviceModel">
						<el-input 
							v-model="addFormObject.deviceModel"
							maxlength="50" 
							placeholder="请输入设备型号（选填）"
							v-if="formTitle=='新增电站'"
							class="dialog-input"
						/>
						<el-row v-if="formTitle!='新增电站'">{{addFormObject.deviceModel || '未填写'}}</el-row>
					  </el-form-item>
				  </el-col>
				  <el-col :span="12">
					  <el-form-item label="设备串号" prop="serNo">
						<el-input
							v-model="addFormObject.serNo"
							maxlength="50"
							placeholder="请输入设备串号（选填）"
							v-if="formTitle=='新增电站'"
							class="dialog-input"
						/>
						<el-row v-if="formTitle!='新增电站'">{{addFormObject.serNo || '未填写'}}</el-row>
					  </el-form-item>
				  </el-col>
			  </el-row>
			  <el-row v-if="formTitle=='新增电站'">
				  <el-col :span="12">
					  <el-form-item label="设备版本号" prop="versionNo">
						<el-input
							v-model="addFormObject.versionNo"
							maxlength="50"
							placeholder="请输入设备版本号（选填）"
							v-if="formTitle=='新增电站'"
							class="dialog-input"
						/>
						<el-row v-if="formTitle!='新增电站'">{{addFormObject.versionNo || '未填写'}}</el-row>
					  </el-form-item>
				  </el-col>
				  <el-col :span="12">
					  <el-form-item label="物联网卡" prop="iccid">
						<el-input
							v-model="addFormObject.iccid"
							maxlength="50"
							placeholder="请输入物联网卡号（选填）"
							v-if="formTitle=='新增电站'"
							class="dialog-input"
						/>
						<el-row v-if="formTitle!='新增电站'">{{addFormObject.iccid || '未填写'}}</el-row>
					  </el-form-item>
				  </el-col>
			  </el-row>
		    <el-form-item v-if="formTitle!='查看电站' && canEdit === 1" class="station-form-actions-item">
			  <div class="station-form-actions">
				<el-button @click="showAdd = false;" class="dialog-cancel-btn">取消</el-button>
				<el-button type="primary" @click="addDeviceSub()" class="dialog-save-btn" :disabled="stationImageUploading">保存</el-button>
			  </div>
		    </el-form-item>
		  </el-form>
		</el-dialog>
		<!-- 地图选择弹窗：深蓝调 -->
		<el-dialog
		  :title="optTitle"
		  :visible.sync="showMap"
		  @close="showAdd = true;"
		  width="850px"
		  class="station-map-dialog-wrapper"
		  custom-class="station-dialog"
		  style="--el-dialog-bg-color: var(--solar-on-primary, #002B4D);--el-dialog-title-color: var(--solar-text-strong, #B0E2FF);border: 1px solid var(--solar-border-strong, #0099FF);"
		>
		  <div class="station-map-content">
			  <el-amap vid="amap" :zoom="zoom" :center="center" ref="map" class="amap-demo">
				  <el-amap-search-box 
				  	:visible="visibleSearch" 
				  	@select.native="selectPoi();"
				  	:search-option="searchOption" 
				  	:on-search-result="getSearchOption"
				  />
				  <el-amap-marker v-if="marker.length > 0":position="marker" draggable="false" />
			  </el-amap>
			  <div class="station-map-actions">
				  <el-button class="station-map-save-btn" @click="sureValue()">保存</el-button>
			  </div>
		  </div>
		</el-dialog>
	</div>
</template>

<script>
	import ManagementTable from '../../components/ManagementTable.vue';
	import { getAccountPermission } from '../../utils/accountPermission';

	export default {
		components: {
			ManagementTable
		},
		data() {
		  return {
			  optTitle:"站点位置选择",
			  canEdit:1,
			  marker:[],
			  searchOption: {
			    city: '',
			    citylimit: false
			  },
			  zoom: 12,
			  center: [117.970675, 37.38268],
			  draggable: false,
			  visible: true,
			  editRan: true,
			  path: [[117.976759, 37.387188], [117.964630, 37.378860]],
			  visibleSearch: true,
			  showMap:false,
			  imageUrl:'',
			  stationPersistedPicKey:'',
			  stationPersistedPreviewUrl:'',
			  stationImageUploading:false,
			  viewportWidth: window.innerWidth || 0,
			  srcList:[],
			  formTitle:'新增电站',
			  addFormObject:{
				  companyName:'',stationName:'',stationType:null,investBody:'',consumptionType:null
				  ,stationAddress:'',id:0,userName:'',linkMobile:'',registrationTime:null,openTime:null,deviceModel:'',
				  serNo:'',versionNo:'',iccid:'',installedCapacity:null,picUrl:'',stationImageUploadTaskNo:'',longitude:'',latitude:'',priceOfMoney:''
			  },
			  showAdd:false,
			  loading:false,
			  tableData:[],
			  allStationList:[],
			  stationList:[],
			  total: 0, 
			  query: {
			    pageNum: 1,
			    pageSize: 6,
				stationId: null,
			  },
		  }
		},
		computed: {
			operationColumnWidth() {
				return this.viewportWidth <= 760 ? 118 : 150;
			}
		},
		mounted() {
			document.title='智能叠光控制系统';
			window.addEventListener('resize', this.updateViewportWidth);
			this.canEdit = getAccountPermission();
			this.loadStationOptions();
			this.serch();
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.updateViewportWidth);
		},
		methods:{
			updateViewportWidth() {
				this.viewportWidth = window.innerWidth || 0;
			},
			loadStationOptions() {
				this.$request.get('/api/power/station/options').then(response => {
					if (response.data.result) {
						this.allStationList = response.data.data || [];
						this.stationList = this.allStationList.slice();
					} else {
						this.$Message.error('获取电站列表失败,请联系管理员!');
					}
				}).catch(() => {
					this.$Message.error('网络异常，获取电站列表失败！');
				});
			},
			filterStation(value) {
				const keyword = String(value || '').trim().toLocaleLowerCase();
				this.stationList = keyword ? this.allStationList.filter(item =>
					String(item.stationName || '').toLocaleLowerCase().includes(keyword)
				) : this.allStationList.slice();
			},
			onStationDropdownVisible(visible) {
				if (visible) this.stationList = this.allStationList.slice();
			},
			// 新增：打开地图选择的方法
			openMapSelect() {
				this.showAdd = false;
				this.showMap = true;
			},
			// 优化：地图保存逻辑，保留手动输入内容
			sureValue(){
				this.addFormObject.longitude = this.addFormObject.longitude1;
				this.addFormObject.latitude = this.addFormObject.latitude1;
				// 只有地图选择了地址才更新，手动输入的保留
				if(this.addFormObject.stationAddress1) {
					this.addFormObject.stationAddress = this.addFormObject.stationAddress1;
				}
				this.optTitle = "(已选择:"+this.addFormObject.stationAddress+")";
				this.showMap = false;
				this.showAdd = true;
			},
			//点击搜索框
			getSearchOption(pois){
				if(pois && pois.length > 0){
					this.addFormObject.longitude1 = pois[0].lng;
					this.addFormObject.latitude1 = pois[0].lat;
					this.marker = [pois[0].lng, pois[0].lat];
					this.center = [pois[0].lng, pois[0].lat];
					this.addFormObject.stationAddress1 = pois[0].name;
					this.optTitle = "(已选择:"+this.addFormObject.stationAddress1+")";
				}
			},
			// 电站图片上传：只直传对象存储，保存电站时再由服务端确认任务
			async handleAvatarSuccess(uploadRequest) {
				const file = uploadRequest.file;
				const contentType = file.type === 'image/png' ? 'image/png' : 'image/jpeg';
				this.$set(this.addFormObject, 'stationImageUploadTaskNo', '');
				this.$set(this.addFormObject, 'picUrl', this.stationPersistedPicKey);
				if (this.imageUrl && this.imageUrl.indexOf('blob:') === 0) {
					URL.revokeObjectURL(this.imageUrl);
				}
				this.imageUrl = this.stationPersistedPreviewUrl;
				this.stationImageUploading = true;
				try {
					const stationId = Number(this.addFormObject.id) > 0
						? Number(this.addFormObject.id) : undefined;
					const presignResponse = await this.$request.post('/api/upload/presign', {
						businessType: 'POWER_STATION_IMAGE',
						businessId: stationId,
						fileName: file.name,
						contentType: contentType,
						fileSize: file.size
					});
					if (!presignResponse.data.result || !presignResponse.data.data) {
						throw new Error(presignResponse.data.message || '获取电站图片上传地址失败');
					}

					const uploadTask = presignResponse.data.data;
					const putResponse = await fetch(uploadTask.uploadUrl, {
						method: 'PUT',
						headers: uploadTask.requiredHeaders || {'Content-Type': contentType},
						body: file,
						credentials: 'omit'
					});
					if (!putResponse.ok) {
						throw new Error('对象存储上传失败（HTTP ' + putResponse.status + '）');
					}

					this.$set(this.addFormObject, 'picUrl', uploadTask.objectKey);
					this.$set(this.addFormObject, 'stationImageUploadTaskNo', uploadTask.taskNo);
					if (this.imageUrl && this.imageUrl.indexOf('blob:') === 0) {
						URL.revokeObjectURL(this.imageUrl);
					}
					this.imageUrl = URL.createObjectURL(file);
					this.$message.success('电站图片已上传，保存电站后生效');
					if (uploadRequest.onSuccess) uploadRequest.onSuccess(uploadTask);
				} catch (error) {
					const responseMessage = error && error.response && error.response.data
						&& error.response.data.message;
					const message = responseMessage || (error && error.message)
						|| '电站图片上传失败，请稍后重试';
					this.$message.error(message);
					if (uploadRequest.onError) uploadRequest.onError(error);
				} finally {
					this.stationImageUploading = false;
				}
			},
		    //图片上传前校验
		    beforeAvatarUpload(file) {
				const isImage = file.type === 'image/jpeg' || file.type === 'image/png';
				const isLt2M = file.size <= 2 * 1024 * 1024;
		
				if (!isImage) {
				  this.$message.error('上传电站图片仅支持 JPG、JPEG 或 PNG 格式!');
				}
				if (!isLt2M) {
				  this.$message.error('上传图片大小不能超过 2MB!');
				}
			    return isImage && isLt2M;
			},
			//图片预览
			viewPic(url){
				this.srcList = [url];
			},
			//表单提交
			addDeviceSub(){
				if(this.stationImageUploading) return this.$Message.warning("电站图片正在上传，请稍候!");
				//基础校验
				if(!this.addFormObject.companyName) return this.$Message.error("公司名称不能为空!");
				if(!this.addFormObject.stationName) return this.$Message.error("站点名称不能为空!");
				if(!this.addFormObject.stationType) return this.$Message.error("电站类型不能为空!");
				if(!this.addFormObject.investBody) return this.$Message.error("投资主体不能为空!");
				if(!this.addFormObject.consumptionType) return this.$Message.error("消纳类型不能为空!");
				if(!this.addFormObject.stationAddress) return this.$Message.error("站点位置不能为空!");
				if(!this.addFormObject.userName) return this.$Message.error("负责人不能为空!");
				if(!this.addFormObject.linkMobile) return this.$Message.error("联系电话不能为空!");
				if(!this.addFormObject.priceOfMoney) return this.$Message.error("单价不能为空!");
				this.$request.post('/api/power/station/edit',this.addFormObject).then(response => {
					if(response.data.result){
						this.serch();
						this.showAdd = false;
						this.$Message.success(this.formTitle === "新增电站" ? "新增电站成功!" : "编辑电站成功!");
					}else{
						this.$Message.error(response.data.message || "操作失败,请联系管理员!");
					}
				}).catch(err => {
					const message = err && err.response && err.response.data && err.response.data.message;
					this.$Message.error(message || "网络异常，操作失败！");
				})
			},
			//删除
			deleteRow(id){
				this.$confirm('确认删除此电站吗?', '提示', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				  type: 'warning',
				  confirmButtonColor: '#FF6666',
				  cancelButtonColor: '#003C66'
				}).then(() => {
					this.$request.delete('/api/power/station/delete/'+id).then(response => {
						if(response.data.result){
							this.serch();
							this.$Message.success("删除电站成功!");
						}else{
							this.$Message.error("删除失败,请联系管理员!");
						}
					}).catch(err => {
						this.$Message.error("网络异常，删除失败！");
					})	
				}).catch(() => {});
			},
			//加载详情数据
			infoView(id){
				this.$request.get('/api/power/station/info/'+id).then(response => {
					if(response.data.result){
						this.addFormObject = response.data.data;
						this.$set(this.addFormObject, 'stationImageUploadTaskNo', '');
						this.imageUrl = this.addFormObject.picUrl;
						this.addFormObject.picUrl = this.addFormObject.picKey || this.addFormObject.picUrl;
						this.stationPersistedPicKey = this.addFormObject.picUrl;
						this.stationPersistedPreviewUrl = this.imageUrl;
						// 处理类型文本显示
						this.addFormObject.stationTypeText = this.addFormObject.stationType === 1 ? "基站叠光" : "离网电站";
						this.addFormObject.consumptionTypeText = {
							1: "全部自用", 2: "余额上网", 3: "全额上网"
						}[this.addFormObject.consumptionType] || "";
						// 处理时间格式化
						this.addFormObject.registrationTimeText = this.addFormObject.registrationTime || "";
						this.addFormObject.openTimeText = this.addFormObject.openTime || "";
						this.showAdd = true;
					}else{
						this.$Message.error("获取数据失败,请联系管理员!");
					}
				}).catch(err => {
					this.$Message.error("网络异常，获取详情失败！");
				})	
			},
			//显示添加
			addDevice(){
				this.addFormObject = {
					companyName:'',stationName:'',stationType:null,investBody:'',consumptionType:null
					,stationAddress:'',id:0,userName:'',linkMobile:'',registrationTime:null,openTime:null,deviceModel:'',
					serNo:'',versionNo:'',iccid:'',installedCapacity:null,picUrl:'',stationImageUploadTaskNo:'',longitude:'',latitude:'',priceOfMoney:''
				};
				this.imageUrl = '';
				this.stationPersistedPicKey = '';
				this.stationPersistedPreviewUrl = '';
				this.formTitle = '新增电站';
				this.showAdd = true;
			},
			// 页数改变时触发
			onPageChange(val) {
			  this.query.pageNum = val
			  this.loadPage()
			},
			/**
			 * 查询
			 */
			serch(){
				this.query.pageNum = 1;
				this.loadPage();
			},
			/**
			 * 加载分页
			 */
			loadPage(){
				this.loading = true;
				this.$request.post("/api/power/station/page",this.query).then(response =>{
					if(response.data.result){
						this.tableData = response.data.data.list;
						this.total = response.data.data.totalCount;
					}else{
						this.$Message.error("获取数据失败,请联系管理员!");
					}
				}).catch(err => {
					this.$Message.error("网络异常，获取数据失败！");
				}).finally(() => {
					this.loading = false;
				})
			}
		}
	}
</script>

<style>
	/* 全局样式：无scoped，覆盖ElementUI */
	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}
	/* 图片上传样式 */
	.avatar-uploader .el-upload {
	    border: 1px dashed var(--solar-border-strong, #0099FF);
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	    background-color: var(--solar-page, #001A33);
	}
	.avatar-uploader .el-upload:hover {
	    border-color: var(--solar-border-strong, #00CCFF);
	}
	.avatar-uploader-icon {
	    font-size: 28px;
	    color: var(--solar-text, #87CEFA);
	    width: 178px;
	    height: 178px;
	    text-align: center;
		line-height: 178px;
	}
	.avatar {
	    width: 178px;
	    height: 178px;
	    display: block;
	    border-radius: 4px;
	}
	/* 弹窗输入框/选择器/日期选择器 */
	.dialog-input, .dialog-select, .dialog-picker {
		background-color: var(--solar-page, #001A33) !important;
		border: 1px solid var(--solar-border-strong, #0099FF) !important;
		border-radius: 4px;
		color: var(--solar-text, #87CEFA) !important;
		overflow: hidden;
		box-shadow: none !important;
		box-sizing: border-box;
	}
	.dialog-input .el-input,
	.dialog-select .el-select,
	.dialog-select .el-input,
	.dialog-picker .el-input {
		border: 0 !important;
		box-shadow: none !important;
	}
	.dialog-input .el-input__wrapper,
	.dialog-select .el-input__wrapper,
	.dialog-select .el-select__wrapper,
	.dialog-picker .el-input__wrapper {
		background: transparent !important;
		border: 0 !important;
		box-shadow: none !important;
	}
	.dialog-input .el-input__inner,
	.dialog-select .el-input__inner,
	.dialog-picker .el-input__inner {
		border: 0 !important;
		background: transparent !important;
		box-shadow: none !important;
	}
	/* 日期选择器直接使用深色底，避免 Element UI 的默认白底透出。 */
	.station-dialog .dialog-picker.el-date-editor,
	.station-dialog .dialog-picker.el-date-editor.el-input,
	.station-dialog .dialog-picker.el-date-editor .el-input__inner {
		background: var(--solar-page, #001A33) !important;
	}
	/* 日期面板会挂载到 body，不能依赖电站弹窗作为父级。 */
	.el-picker-panel.el-date-picker,
	.el-picker-panel.el-date-picker .el-picker-panel__body-wrapper,
	.el-picker-panel.el-date-picker .el-picker-panel__footer {
		background: var(--solar-surface, #002B4D) !important;
		color: var(--solar-text, #87CEFA) !important;
	}
	.station-date-picker-panel .el-picker-panel__footer .el-picker-panel__link-btn.el-button--text {
		min-width: 52px;
		padding: 7px 12px !important;
		box-sizing: border-box;
	}
	/* 弹窗按钮 */
	.dialog-save-btn {
		background-color: var(--solar-primary, #0099FF) !important;
		border: none !important;
		color: var(--solar-text-strong, #fff) !important;
	}
	.dialog-cancel-btn {
		background-color: var(--solar-raised, #003C66) !important;
		border: 1px solid var(--solar-border-strong, #0099FF) !important;
		color: var(--solar-text, #87CEFA) !important;
	}
	/* ElementUI组件全局覆盖 */
	.el-table {
		background-color: var(--solar-surface, #002B4D) !important;
		color: var(--solar-text, #87CEFA) !important;
	}
	.el-table__header th {
		background-color: var(--solar-page, #001A33) !important;
		color: var(--solar-text-strong, #B0E2FF) !important;
		border-bottom: 1px solid var(--solar-border, #003C66) !important;
	}
	.el-table__row {
		border-bottom: 1px solid var(--solar-border, #003C66) !important;
	}
	.el-table__row:hover {
		background-color: var(--solar-raised, #003C66) !important;
	}
	.el-table--border {
		border: none !important;
	}
	.el-table--border th, .el-table--border td {
		border-right: 1px solid var(--solar-border, #003C66) !important;
	}
	.power-station-page .el-table::before,
	.power-station-page .el-table::after,
	.power-station-page .el-table__fixed-right::before,
	.power-station-page .el-table__fixed::before {
		display: none !important;
	}
	.power-station-page .el-table__body-wrapper {
		background-color: var(--solar-surface, #002B4D) !important;
		scrollbar-width: thin;
		scrollbar-color: rgba(var(--solar-primary-rgb, 0, 153, 255), 0.45) rgba(0, 26, 51, 0.25);
	}
	.power-station-page .el-table__body-wrapper::-webkit-scrollbar:horizontal {
		height: 8px;
	}
	.power-station-page .el-table__body-wrapper::-webkit-scrollbar-thumb:horizontal {
		background: linear-gradient(90deg, rgba(var(--solar-primary-rgb, 0, 153, 255), 0.2), rgba(var(--solar-primary-rgb, 0, 204, 255), 0.42), rgba(var(--solar-primary-rgb, 0, 153, 255), 0.2));
		border: 2px solid var(--solar-border, #001A33);
		border-radius: 999px;
	}
	.power-station-page .el-table__body-wrapper::-webkit-scrollbar-track:horizontal {
		background: var(--solar-page, #001A33);
		border-top: 1px solid rgba(var(--solar-border-strong-rgb, 0, 153, 255), 0.14);
		border-radius: 0 0 6px 6px;
	}
	.power-station-page .el-table__fixed-right {
		right: 0 !important;
		background-color: var(--solar-surface, #002B4D) !important;
		box-shadow: -8px 0 16px rgba(var(--solar-page-rgb, 0, 18, 36), 0.16);
	}
	.power-station-page .el-table__fixed-right-patch {
		background-color: var(--solar-page, #001A33) !important;
		border-bottom: none !important;
	}
	.power-station-page .el-table th.gutter,
	.power-station-page .el-table colgroup.gutter {
		background-color: var(--solar-page, #001A33) !important;
	}
	/* 修复分页按钮不可见：强制设置颜色 */
	.el-pagination {
		--el-pagination-text-color: var(--solar-text, #87CEFA) !important;
		--el-pagination-button-color: var(--solar-on-primary, #002B4D) !important;
		--el-pagination-button-hover-color: var(--solar-on-primary, #003C66) !important;
		--el-pagination-button-active-color: var(--solar-primary, #0099FF) !important;
	}
	.el-pagination__editor input {
		background-color: var(--solar-page, #001A33) !important;
		border: 1px solid var(--solar-border-strong, #0099FF) !important;
		color: var(--solar-text, #87CEFA) !important;
	}
	.el-dialog__header {
		border-bottom: 1px solid var(--solar-border, #003C66) !important;
	}
	.el-dialog__close {
		color: var(--solar-text, #87CEFA) !important;
	}
	.el-dialog__close:hover {
		color: var(--solar-primary, #00CCFF) !important;
	}
	.el-form-item__label {
		color: var(--solar-text, #87CEFA) !important;
	}
	.el-input__placeholder, .el-select__placeholder {
		color: var(--solar-muted, #6699CC) !important;
	}
	.el-select-dropdown {
		background-color: var(--solar-surface, #002B4D) !important;
		border: 1px solid var(--solar-border-strong, #0099FF) !important;
	}
	.el-select-dropdown__item {
		color: var(--solar-text, #87CEFA) !important;
	}
	.el-select-dropdown__item:hover {
		background-color: var(--solar-raised, #003C66) !important;
		color: var(--solar-primary, #00CCFF) !important;
	}
	.el-date-picker__editor {
		background-color: var(--solar-page, #001A33) !important;
	}
	.el-date-picker__panel {
		background-color: var(--solar-surface, #002B4D) !important;
		border: 1px solid var(--solar-border-strong, #0099FF) !important;
	}
	.el-date-table td {
		color: var(--solar-text, #87CEFA) !important;
	}
	.el-date-table td:hover {
		background-color: var(--solar-raised, #003C66) !important;
	}
	.el-date-table .el-date-table__current-day {
		color: var(--solar-primary, #00CCFF) !important;
	}
	.el-time-panel {
		background-color: var(--solar-surface, #002B4D) !important;
		border: 1px solid var(--solar-border-strong, #0099FF) !important;
	}
	.el-time-panel__content {
		color: var(--solar-text, #87CEFA) !important;
	}
	.el-time-panel__btn {
		color: var(--solar-text, #87CEFA) !important;
	}
	.el-time-panel__btn.confirm {
		color: var(--solar-primary, #00CCFF) !important;
	}
	.el-confirm {
		--el-confirm-bg-color: var(--solar-on-primary, #002B4D) !important;
		--el-confirm-title-color: var(--solar-text-strong, #B0E2FF) !important;
		--el-confirm-content-color: var(--solar-text, #87CEFA) !important;
	}
	.el-message {
		background-color: var(--solar-surface, #002B4D) !important;
		border: 1px solid var(--solar-border-strong, #0099FF) !important;
		color: var(--solar-text, #87CEFA) !important;
	}
	.station-dialog {
		background: var(--solar-page, #00233f) !important;
		border: 1px solid rgba(var(--solar-border-strong-rgb, 63, 184, 255), 0.55);
		border-radius: 8px;
		box-shadow: 0 18px 42px rgba(0, 7, 18, 0.36);
	}
	/* 使用 wrapper 的可用高度居中，消除 Element UI 默认 15vh 顶部偏移造成的滚动条。 */
	.station-form-dialog-wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		overflow: hidden;
	}
	.station-form-dialog-wrapper .station-dialog {
		max-height: calc(100% - 32px);
		margin: 0 !important;
		display: flex;
		flex-direction: column;
	}
	.station-form-dialog-wrapper .station-dialog .el-dialog__body {
		min-height: 0;
		overflow-y: auto;
	}
	.station-dialog .el-dialog__header {
		border-bottom: 1px solid rgba(var(--solar-border-strong-rgb, 63, 184, 255), 0.24) !important;
		background: linear-gradient(90deg, rgba(var(--solar-surface-rgb, 0, 43, 77), 0.95), rgba(var(--solar-page-rgb, 0, 26, 51), 0.78));
	}
	.station-dialog .el-dialog__title,
	.station-dialog .el-dialog__close {
		color: var(--solar-text-strong, #dff8ff) !important;
	}
	.station-dialog .el-dialog__body {
		background: rgba(var(--solar-page-rgb, 0, 31, 61), 0.96);
	}
	/* 查看模式下弱化字段名、提亮字段值，便于快速区分信息层级。 */
	.station-dialog .detail-view-form .el-form-item__label {
		color: var(--solar-muted, #7faec4) !important;
	}
	.station-dialog .detail-view-form .el-form-item__content {
		color: var(--solar-text-strong, #e6f7ff) !important;
	}
	.station-form-section-title {
		display: flex;
		align-items: center;
		gap: 10px;
		margin: 0 0 16px;
		color: var(--solar-text-strong, #dff8ff);
		font-size: 15px;
		font-weight: 600;
		line-height: 22px;
	}
	.station-form-section-title::after {
		content: '';
		flex: 1;
		height: 1px;
		background: linear-gradient(90deg, rgba(var(--solar-primary-rgb, 63, 184, 255), 0.5), rgba(var(--solar-primary-rgb, 63, 184, 255), 0.05));
	}
	.station-device-section-title {
		margin-top: 6px;
		padding-top: 16px;
		border-top: 1px solid rgba(var(--solar-border-strong-rgb, 63, 184, 255), 0.16);
	}
	.station-image {
		width: 112px;
		height: 72px;
		border-radius: 4px;
		object-fit: cover;
	}
	.station-image-empty {
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: var(--solar-raised, #003C66);
		color: var(--solar-text, #87CEFA);
		font-size: 13px;
	}
	.station-table-actions {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 12px;
		width: 100%;
	}
	.station-table-action {
		color: var(--solar-primary, #00CCFF);
		font-size: 14px;
		cursor: pointer;
		white-space: nowrap;
	}
	.station-form-actions {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 20px;
		padding-right: 90px;
	}
	.station-map-content {
		position: relative;
		width: 810px;
		height: 450px;
	}
	.station-map-content .amap-demo {
		width: 100%;
		height: 100%;
	}
	.station-map-actions {
		position: absolute;
		top: 5px;
		left: 380px;
		z-index: 20;
	}
	.station-map-save-btn.el-button {
		width: 80px;
		height: 48px;
		border: 0;
		background-color: var(--solar-primary, #0099FF);
		color: var(--solar-on-primary, #002B4D);
		font-size: 14px;
		font-weight: 600;
	}

	@media screen and (max-width: 760px) {
		.station-form-dialog-wrapper,
		.station-map-dialog-wrapper {
			padding: 8px 0;
		}

		.station-form-dialog-wrapper .station-dialog,
		.station-map-dialog-wrapper .station-dialog {
			width: calc(100% - 16px) !important;
			max-width: 520px;
			max-height: calc(100% - 16px);
			margin: 0 auto !important;
			display: flex;
			flex-direction: column;
		}

		.station-form-dialog-wrapper .station-dialog .el-dialog__header,
		.station-map-dialog-wrapper .station-dialog .el-dialog__header {
			flex: 0 0 auto;
			padding: 14px 16px 12px;
		}

		.station-form-dialog-wrapper .station-dialog .el-dialog__body,
		.station-map-dialog-wrapper .station-dialog .el-dialog__body {
			min-height: 0;
			padding: 14px 12px;
			overflow: auto;
			-webkit-overflow-scrolling: touch;
			overscroll-behavior: contain;
		}

		.station-form-dialog-wrapper .station-dialog .el-col-12,
		.station-form-dialog-wrapper .station-dialog .el-col-24 {
			width: 100%;
			float: none;
		}

		.station-form-dialog-wrapper .station-dialog .el-form-item {
			margin-bottom: 14px;
		}

		.station-form-dialog-wrapper .station-dialog .dialog-input,
		.station-form-dialog-wrapper .station-dialog .dialog-select,
		.station-form-dialog-wrapper .station-dialog .dialog-picker,
		.station-form-dialog-wrapper .station-dialog .el-date-editor {
			width: 100% !important;
		}

		.station-form-section-title {
			margin-bottom: 10px;
		}

		.station-form-actions-item .el-form-item__content {
			margin-left: 0 !important;
		}

		.station-form-actions {
			width: 100%;
			gap: 10px;
			padding-right: 0;
		}

		.station-form-actions .el-button {
			flex: 1 1 0;
			margin-left: 0 !important;
		}

		.station-table-actions {
			gap: 8px;
		}

		.station-table-action {
			min-width: 28px;
			font-size: 13px;
		}

		.station-map-dialog-wrapper {
			display: flex;
			align-items: center;
			justify-content: center;
			overflow: hidden;
		}

		.station-map-content {
			width: 100%;
			height: min(450px, calc(100vh - 132px));
			min-height: 300px;
		}

		.station-map-actions {
			top: 8px;
			right: 8px;
			left: auto;
		}

		.station-map-save-btn.el-button {
			width: 72px;
			height: 40px;
			padding: 0 12px;
		}

		.station-map-dialog-wrapper .el-vue-search-box-container {
			position: absolute !important;
			top: 8px !important;
			left: 8px !important;
			width: calc(100% - 96px) !important;
			height: 40px !important;
		}

		.station-date-picker-panel.el-picker-panel {
			max-width: calc(100vw - 16px);
		}
	}
	/* 滚动条样式 */
	::-webkit-scrollbar {
		width: 6px;
		height: 6px;
		background-color: var(--solar-page, #001A33);
	}
	::-webkit-scrollbar-thumb {
		background-color: var(--solar-primary, #0099FF);
		border-radius: 3px;
	}
	::-webkit-scrollbar-track {
		background-color: var(--solar-surface, #002B4D);
		border-radius: 3px;
	}
</style>

<style scoped>
.power-station-page {
	width: 100%;
	height: 100%;
	min-height: 0;
}

/deep/ .dialog-input .el-input,
/deep/ .dialog-select .el-select,
/deep/ .dialog-select .el-input,
/deep/ .dialog-picker .el-input {
	border: 0 !important;
	box-shadow: none !important;
}

/deep/ .dialog-input .el-input__wrapper,
/deep/ .dialog-select .el-input__wrapper,
/deep/ .dialog-select .el-select__wrapper,
/deep/ .dialog-picker .el-input__wrapper,
/deep/ .dialog-input .el-input__wrapper:hover,
/deep/ .dialog-select .el-input__wrapper:hover,
/deep/ .dialog-picker .el-input__wrapper:hover {
	background: transparent !important;
	border: 0 !important;
	box-shadow: none !important;
}

/deep/ .el-input__inner {
	height: 36px;
	line-height: 36px;
	border: 0 !important;
	background: transparent !important;
	color: var(--solar-text-strong, #dff8ff) !important;
	box-shadow: none !important;
}

/deep/ .el-input__inner::placeholder {
	color: var(--solar-muted, #6d9db6);
}

/deep/ .el-select {
	width: 100%;
}

/deep/ .dialog-save-btn.el-button {
	background-color: var(--solar-primary, #0099FF) !important;
	border-color: var(--solar-border-strong, #0099FF) !important;
	color: var(--solar-on-primary, #002B4D) !important;
	font-size: 14px;
	font-weight: 600;
	line-height: 1;
}

/deep/ .dialog-cancel-btn.el-button {
	color: var(--solar-text, #87CEFA) !important;
	font-size: 14px;
	font-weight: 600;
	line-height: 1;
}

/deep/ .el-vue-search-box-container {
	position: relative;
	width: 360px;
	height: 45px;
	background: var(--solar-surface, #002B4D);
	border: 1px solid var(--solar-border-strong, #0099FF);
	box-shadow: 0 2px 8px rgba(var(--solar-primary-rgb, 0, 153, 255), 0.2);
	border-radius: 4px;
	z-index: 10;
	top: -445px;
	left: 5px;
	color: var(--solar-text, #87CEFA);
}

/deep/ .el-vue-search-box-container .search-box-wrapper input {
	height: 100% !important;
	border: 0 !important;
	outline: none;
	background-color: var(--solar-page, #001A33) !important;
	color: var(--solar-text, #87CEFA) !important;
	box-shadow: none !important;
}

/deep/ .el-vue-search-box-container .search-tips {
	background-color: var(--solar-surface, #002B4D) !important;
	border-color: var(--solar-border-strong, #0099FF) !important;
	color: var(--solar-text, #87CEFA) !important;
}

/deep/ .el-vue-search-box-container .search-tips li.autocomplete-selected {
	background-color: var(--solar-raised, #003C66) !important;
}

/deep/ .el-vue-search-box-btn {
	background-color: var(--solar-primary, #0099FF) !important;
	color: var(--solar-on-primary, #002B4D) !important;
	font-size: 14px;
	font-weight: 600;
}

</style>
